import { FormControl, FormControlProps, FormHelperText } from '@mui/material';
import { DatePickerProps } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from 'src/components/DatePicker';
import { CommonFormFieldProps, useWatchConditions } from '..';

export type FormDatePickerProps = Omit<
  FormControlProps,
  'required' | 'defaultValue' | 'name' | 'type'
> & {
  name: string;
  label?: string;
  required?: boolean | string;
  datePickerProps?: Partial<DatePickerProps<Dayjs>>;
  value?: Dayjs | null;
  showErrorText?: boolean;
  rules?: Record<string, unknown>;
} & CommonFormFieldProps<'datepicker', Dayjs>;

export const FormDatePicker = (props: FormDatePickerProps) => {
  const {
    name,
    label,
    required,
    datePickerProps,
    value,
    fullWidth,
    showsIf = [],
    rules,
    showErrorText,
    disabled,
  } = props;

  const { control, formState } = useFormContext();
  const errorMsg = formState.errors[name]?.message;

  const shouldShow = useWatchConditions({
    control,
    showsIf,
  });

  if (!shouldShow) {
    return null;
  }

  return (
    <FormControl error={!!errorMsg} fullWidth={fullWidth}>
      <Controller
        name={name}
        control={control}
        rules={{ ...rules, required }}
        render={({ field }) => (
          <DatePicker
            // @ts-expect-error Figure out why label type is not compatible
            label={label}
            errorMsg={errorMsg ? String(errorMsg) : undefined}
            {...datePickerProps}
            {...field}
            value={(field.value as Dayjs) ?? value}
            disabled={disabled}
            slotProps={{
              ...datePickerProps?.slotProps,
            }}
          />
        )}
      />
      {!!showErrorText && !!errorMsg && <FormHelperText>{String(errorMsg)}</FormHelperText>}
    </FormControl>
  );
};
